<template>
  <div class="scale-card" v-on:click="show(scale)">
    <span class="scale-top">{{ scale.manufacturer }} {{ scale.model }}</span>

    <span v-if="scale.comment" class="scale-comment">{{ scale.comment }}</span>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "ScaleCard",
  props: {
    scale: Object
  },
  data: function() {
    return { store: store };
  },
  methods: {
    initData: function() {},
    show: function(scale) {
      this.$router.push({
        name: "scales.show",
        params: { id: scale.id }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scale-card {
  cursor: pointer;
  border-radius: 0.25rem;
  /* width: 18rem; */
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 1rem;
  margin-bottom: 1rem;
}
.scale-top {
  display: block;
  font-size: 120%;
  color: #111;
}

.scale-comment {
  font-size: 90%;
  color: gray;
  display: block;
}
</style>
